export default __webpack_public_path__ + "static/media/background_blog_desktop.045061ae.png";